import { CONVERSATION_EVENT_COMPLETE_BY, CONVERSATION_EVENT_STATUS } from '../../apps/meetings/models/meeting';

export const CheckinsHeader = ({
  header,
  status,
  participant,
  completedBy,
  completedByUser,
  completedAt,
  startDate,
  endDate,
  meeting_invitees,
  woboLogo,
}) => {
  const participantInvitee = meeting_invitees.find((user) => user.user_id == participant);
  const participantName = participantInvitee && participantInvitee.user_name;

  const startUTC = new Date(startDate + 'Z');
  const endUTC = new Date(endDate + 'Z');
  const completedAtUTC = completedAt ? new Date(completedAt + 'Z') : null;

  let statusString = '';
  if (status == CONVERSATION_EVENT_STATUS.COMPLETED) {
    const completedAtFormatted = completedAtUTC
      ? completedAtUTC.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      : 'Incomplete';
    if (completedBy == CONVERSATION_EVENT_COMPLETE_BY.MANAGER || completedBy == CONVERSATION_EVENT_COMPLETE_BY.MEMBER) {
      const completedByInvitee = meeting_invitees.find((user) => user.user_id == completedByUser);
      const completedByName = completedByInvitee && completedByInvitee.user_name;
      statusString = `Marked Complete by ${completedByName} on ${completedAtFormatted}`;
    }
    if (completedBy == CONVERSATION_EVENT_COMPLETE_BY.HR) {
      statusString = `Marked Complete by HR on ${completedAtFormatted}`;
    }
  }
  if (status == CONVERSATION_EVENT_STATUS.INCOMPLETE) {
    statusString = 'Incomplete';
  }
  if (status == CONVERSATION_EVENT_STATUS.NOT_REQUIRED) {
    statusString = 'Not required'
  }
  if (status == CONVERSATION_EVENT_STATUS.CREATED) {
    const statusDueDate = endUTC.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    statusString = `Due before ${statusDueDate}`;
  }

  const startDateFormatted = startUTC.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const endDateFormatted = endUTC.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <div
      style={{
        position: 'relative',
        paddingTop: '20px',
        textAlign: 'left',
        borderBottom: '1px solid #D7DDE5',
        paddingBottom: '20px',
        width: '100%',
        paddingRight: '10px',
        marginBottom: '40px',
      }}
    >
      <h1 style={{ fontSize: '20px', color: '#000', fontWeight: '600' }}>{header}</h1>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
        <span
          style={{
            fontFamily: 'Lato',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: '400',
            color: 'rgba(0, 0, 0, 0.6)',
            marginRight: '6px',
          }}
        >
          For:
        </span>
        <img
          style={{ borderRadius: '50%', height: '18px', width: '18px', marginRight: '6px', verticalAlign: 'middle' }}
          src={participantInvitee?.picture}
          alt="User Picture"
        />
        <span style={{ fontFamily: 'Lato', fontSize: '14px', fontWeight: '400' }}>{participantName}</span>
      </div>
      <p
        style={{
          fontFamily: 'Lato',
          fontSize: '16px',
          fontWeight: '400',
          margin: '10px 0 0 0',
          paddingLeft: '0px',
          textAlign: 'left',
        }}
      >
        {statusString}
      </p>
      <p
        style={{
          fontFamily: 'Lato',
          fontSize: '14px',
          fontStyle: 'italic',
          fontWeight: '400',
          color: 'rgba(0, 0, 0, 0.6)',
          margin: '5px 0 0 0',
          paddingLeft: '0px',
          textAlign: 'left',
        }}
      >
        {`${startDateFormatted} - ${endDateFormatted}`}
      </p>
      <div style={{ position: 'absolute', top: 20, right: 0 }}>
        <img src={woboLogo} width="117px" height="auto" />
      </div>
    </div>
  );
};
